import React from "react";
import styles from "./styles.module.css"
import clsx from "clsx";
import { useTranslation } from "react-i18next";

interface ProgressbarProps {
  value: number;
  max: number;
  entriesStatusClassName?: string;
}

const ProgressBar: React.FC<ProgressbarProps> = ({ value, max, entriesStatusClassName }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.progressContainer}>
        <progress className={styles.progressBar} value={value} max={max} />
        <div className={clsx(styles.entriesStatus, entriesStatusClassName, "fontWeightRegular fontSizeSm12 fontColor666")}>
          {t("poolFilled", { value, max })}
        </div>
      </div>
    </>
  )
}

export default ProgressBar;